/* WME - honest 2pm UK cutoff countdown. Used outside the PDP. */
(function () {
  var els = document.querySelectorAll('[data-wme-clock]');
  if (!els.length) return;
  if (document.querySelector('[data-wme-pdp]')) return; /* PDP script owns its own clock */
  function parts(d) {
    try {
      var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit' });
      var o = {};
      f.formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
      return o;
    } catch (e) { return null; }
  }
  function tick() {
    var p = parts(new Date());
    if (!p) return;
    var now = parseInt(p.hour, 10) * 3600 + parseInt(p.minute, 10) * 60 + parseInt(p.second, 10);
    var diff = (14 * 3600) - now;
    if (diff <= 0) diff += 24 * 3600;
    var hrs = Math.floor(diff / 3600);
    var min = Math.floor((diff % 3600) / 60);
    var txt = hrs + 'h ' + (min < 10 ? '0' : '') + min + 'm left';
    for (var i = 0; i < els.length; i++) els[i].textContent = txt;
  }
  tick();
  setInterval(tick, 30000);
})();
